export default __webpack_public_path__ + "static/media/pie.58fe4f69.svg";